import React, { Suspense } from "react";
import { useModalContext } from "../../context/ModalContext";

const ConfirmationPopup = React.lazy(() => import("../../Layouts/Modal/ConfirmationPopup"));
const FormBuilderDeletePopup = React.lazy(() => import("../../Layouts/Modal/FormBuilderDeletePopup"));

const GlobalModals = () => {
  const { deleteModal, confirmationModal } = useModalContext();

  return (
    <Suspense fallback={null}>
      <>
        {confirmationModal.show && <ConfirmationPopup message={confirmationModal.message} />}
        {deleteModal.show && (
          <FormBuilderDeletePopup
            action={deleteModal.action}
            message={deleteModal.item}
            show={deleteModal.show}
            info={deleteModal.info}
          />
        )}
      </>
    </Suspense>
  );
};

export default React.memo(GlobalModals);
